export const ACTIONS = {
  SET_CAPITAL: "SET_CAPITAL",
};
